import React from 'react'
function Hero() {
    return ( 
        <div className='container text-center p-5'>
            <div className='row'>
                <h1 className=''>Technology</h1>
                <h2 className='mt-3 text-muted'>Sleek,modern and intuitive platforms</h2>
                <p >check out our <a href="#" style={{textDecoration:"none"}}>investment offerings <i class="fa-solid fa-arrow-right-long"></i></a></p>
            </div>
        </div>
     );
}

export default Hero;